// // // import { Card, Col, Row, Typography, Tag, Button, Dropdown, Menu } from 'antd';
// // // import { DownOutlined } from '@ant-design/icons';

// // // const { Title, Text } = Typography;

// // // const dataBlock = [
// // //   {
// // //     title: 'Summary',
// // //     values: ['kVA T', 'kW T', 'I Avg', 'V LL Avg'],
// // //   },
// // //   {
// // //     title: 'Apparent Power',
// // //     values: ['kVA r', 'kVA y', 'kVA b', 'kVA T'],
// // //   },
// // //   {
// // //     title: 'Real Power',
// // //     values: ['kW r', 'kW y', 'kW b', 'kW T'],
// // //   },
// // //   {
// // //     title: 'Reactive Power',
// // //     values: ['kVAr r', 'kVAr y', 'kVAr b', 'kVAr T'],
// // //   },
// // //   {
// // //     title: 'Energies',
// // //     values: ['kWh Imp', 'kWh Exp', 'kVAh Imp', 'kVAh Exp'],
// // //   },
// // //   {
// // //     title: 'PF',
// // //     values: ['PF r', 'PF y', 'PF b', 'PF T'],
// // //   },
// // //   {
// // //     title: 'Voltage',
// // //     values: ['V LL r', 'V LL y', 'V LL b', 'V LL Avg'],
// // //   },
// // //   {
// // //     title: 'Current',
// // //     values: ['I r', 'I y', 'I b', 'I Avg'],
// // //   },
// // // ];

// // // const MeterStatusView = () => {
// // //   const renderBlock = (title, values) => (
// // //     <Card size="small" title={title} bordered={false} style={{ marginBottom: 16 }}>
// // //       <Row gutter={[8, 8]}>
// // //         {values.map((item, index) => (
// // //           <Col span={12} key={index}>
// // //             <div style={{ background: index === values.length - 1 ? '#f6ffed' : '#e6f7ff', padding: 8, borderRadius: 4 }}>
// // //               <Text strong>{item}</Text>: <Text>46,250.00</Text>
// // //             </div>
// // //           </Col>
// // //         ))}
// // //       </Row>
// // //     </Card>
// // //   );

// // //   const menu = (
// // //     <Menu>
// // //       <Menu.Item key="1">Download as PDF</Menu.Item>
// // //       <Menu.Item key="2">Export as CSV</Menu.Item>
// // //     </Menu>
// // //   );

// // //   return (
// // //     <div style={{ padding: 24, background: '#fff', minHeight: '100vh' }}>
// // //           <Title level={4}>EB IN</Title>
// // //       <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// // //         <div className='flex items-start justify-start'>
// // //           <Text>Meter ID: <strong>MT-2024-0231</strong></Text><br />
// // //           <Text>Last Poll: <strong>2024-02-20 15:30:22</strong></Text>
// // //           <Tag color="green" style={{ marginLeft: 8 }}>Working</Tag>
// // //         </div>
// // //         <Dropdown overlay={menu}>
// // //           <Button>
// // //             Download <DownOutlined />
// // //           </Button>
// // //         </Dropdown>
// // //       </div>

// // //       <Row gutter={[16, 16]}>
// // //         {dataBlock.map((block, idx) => (
// // //           <Col span={6} key={idx}>
// // //             {renderBlock(block.title, block.values)}
// // //           </Col>
// // //         ))}
// // //       </Row>
// // //     </div>
// // //   );
// // // };

// // // export default MeterStatusView;

// // import React, { useRef } from 'react';
// // import { Card, Col, Row, Typography, Tag, Dropdown, Button, Menu } from 'antd';
// // import { DownOutlined } from '@ant-design/icons';
// // import { useSelector } from 'react-redux';
// // import html2canvas from "html2canvas";
// // import jsPDF from "jspdf";
// // import { data } from 'autoprefixer';

// // const { Title, Text } = Typography;

// // const sections = [
// //   {
// //     title: 'Summary',
// //     data: ['kVA T', 'kW T', 'I Avg', 'V LL Avg'],
// //   },
// //   {
// //     title: 'Apparent Power',
// //     data: ['kVA r', 'kVA y', 'kVA b', 'kVA T'],
// //   },
// //   {
// //     title: 'Real Power',
// //     data: ['kW r', 'kW y', 'kW b', 'kW T'],
// //   },
// //   {
// //     title: 'Reactive Power',
// //     data: ['kVAr r', 'kVAr y', 'kVAr b', 'kVAr T'],
// //   },
// //   {
// //     title: 'Energies',
// //     data: ['kWh Imp', 'kWh Exp', 'kVAh Imp', 'kVAh Exp'],
// //   },
// //   {
// //     title: 'PF',
// //     data: ['PF r', 'PF y', 'PF b', 'PF T'],
// //   },
// //   {
// //     title: 'Voltage',
// //     data: ['V LL r', 'V LL y', 'V LL b', 'V LL Avg'],
// //   },
// //   {
// //     title: 'Current',
// //     data: ['I r', 'I y', 'I b', 'I Avg'],
// //   },
// // ];

// // const getCellColor = (index, length) =>
// //   index === length - 1 ? '#f6ffed' : '#e6f7ff';

// // // const menu = (
// // //   <Menu>
// // //     <Menu.Item key="1">Download as PDF</Menu.Item>
// // //     <Menu.Item key="2">Export as CSV</Menu.Item>
// // //   </Menu>
// // // );

// // const EBMeterDashboard = ({parameters}) => {
// //  const componentRef = useRef(null);
// //      const mode = useSelector((state) => state.darkMode);
// //       const color = useSelector((state) => state.ThemeChange);
// //       console.log(color);
// //       const { isdarkMode } = mode
// //       console.log(isdarkMode)
// //       console.log(parameters)
// //   const handleDownload = async (type) => {
// //     const element = componentRef.current;
// //     return;
// //     console.log(element)
// //     if (!element) return;

// //     try {
// //       const canvas = await html2canvas(element, { scale: 2 });
// //       const dataURL = canvas.toDataURL("image/png");

// //       if (type === "png") {
// //         const link = document.createElement("a");
// //         link.href = dataURL;
// //         link.download = "component.png";
// //         link.click();
// //       }

// //       if (type === "pdf") {
// //         const pdf = new jsPDF("p", "mm", "a4");
// //         const imgProps = pdf.getImageProperties(dataURL);
// //         const pdfWidth = pdf.internal.pageSize.getWidth();
// //         const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

// //         pdf.addImage(dataURL, "PNG", 0, 0, pdfWidth, pdfHeight);
// //         pdf.save("component.pdf");
// //       }
// //     } catch (error) {
// //       console.error("Download error:", error);
// //     }
// //   };

// //   const menu = (
// //     <Menu onClick={({ key }) => handleDownload(key)}>
// //       <Menu.Item key="png">Download as PNG</Menu.Item>
// //       <Menu.Item key="pdf">Download as PDF</Menu.Item>
// //     </Menu>
// //   );
// //   return (
// //     <div style={{ }}
// //     ref={componentRef}
// //     className={` ${isdarkMode ? 'bg-transparent' : ''}`}>
// //       {/* Header */}
// //       <div style={{
// //         display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24
// //       }}>
// //         <div className='-mt-5'>
// //           <Title level={4}>{parameters.metername}</Title>
// //           <Text>Meter ID: <strong>{parameters.meterid}</strong></Text><br />
// //           <Text>Last Poll: <strong>2024-02-20 15:30:22</strong></Text>
// //           <Tag color="green" style={{ marginLeft: 8 }}>Working</Tag>
// //         </div>
// //         <Dropdown overlay={menu}>
// //           <Button>
// //             Download <DownOutlined />
// //           </Button>
// //         </Dropdown>
// //       </div>

// //       {/* Cards Grid */}
// //       <Row gutter={[16, 16]} >
// //         {sections.map((section, idx) => (
// //           <Col xs={24} sm={12} md={12} lg={6} key={idx}>
// //             <Card title={section.title} size="small" bordered={false}>
// //               {section.data.map((item, i) => (
// //                 <div
// //                   key={i}
// //                   style={{
// //                     backgroundColor: getCellColor(i, section.data.length),
// //                     padding: '8px 12px',
// //                     marginBottom: 8,
// //                     borderRadius: 4,
// //                   }}
// //                   className='flex items-center justify-between'
// //                 >
// //                   <Text strong>{item}</Text>
// //                   <div><Text>46,250.00</Text></div>
// //                 </div>
// //               ))}
// //             </Card>
// //           </Col>
// //         ))}
// //       </Row>
// //     </div>
// //   );
// // };

// // export default EBMeterDashboard;

// import React, { useRef } from "react";
// import { useSelector } from "react-redux";
// import { Button, Dropdown, Menu, Typography, Tag, Row, Col, Card } from "antd";
// import { DownOutlined } from "@ant-design/icons";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";

// const { Title, Text } = Typography;

// // const getCellColor = (index, total) => {
// //   const intensity = 255 - Math.floor((index / total) * 100);
// //   return `rgb(${intensity}, ${intensity}, ${intensity})`;
// // };
const getCellColor = (index, total) => {
  const ratio = Math.min(index / total, 1);

  const red = 191 - Math.floor(ratio * 80); // 191 → 111
  const green = 246 - Math.floor(ratio * 80); // 246 → 166
  const blue = 209 - Math.floor(ratio * 80); // 209 → 129

  return `rgb(${red}, ${green}, ${blue})`;
};

// const EBMeterDashboard = ({ parameters,data }) => {
//   console.log(data)
//   const componentRef = useRef(null);
//   const mode = useSelector((state) => state.darkMode);
//   const { isdarkMode } = mode;

//   const handleDownload = async (type) => {
//     const element = componentRef.current;
//     if (!element) return;

//     try {
//       const canvas = await html2canvas(element, { scale: 2 });
//       const dataURL = canvas.toDataURL("image/png");

//       if (type === "png") {
//         const link = document.createElement("a");
//         link.href = dataURL;
//         link.download = "component.png";
//         link.click();
//       }

//       if (type === "pdf") {
//         const pdf = new jsPDF("p", "mm", "a4");
//         const imgProps = pdf.getImageProperties(dataURL);
//         const pdfWidth = pdf.internal.pageSize.getWidth();
//         const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

//         pdf.addImage(dataURL, "PNG", 0, 0, pdfWidth, pdfHeight);
//         pdf.save("component.pdf");
//       }
//     } catch (error) {
//       console.error("Download error:", error);
//     }
//   };

//   const menu = (
//     <Menu style={{lineHeight:'1.4'}} onClick={({ key }) => handleDownload(key)}>
//       <Menu.Item style={{lineHeight:'1.4'}} key="png">Download as PNG</Menu.Item>
//       <Menu.Item style={{lineHeight:'1.4'}} key="pdf">Download as PDF</Menu.Item>
//     </Menu>
//   );

//   // Dynamic section definitions from parameters
//   const sections = [
//     {
//       title: "Summary",
//       data: [
//         `kVA T: ${parameters.kvat}`,
//         `kW T: ${parameters.kwt}`,
//         `I Avg: ${parameters.iavg}`,
//         `V LL Avg: ${parameters.vllAvg}`,
//       ],
//     },
//     {
//       title: "Apparent Power",
//       data: [
//         `KVA r: ${parameters.kvA_R}`,
//         `KVA y: ${parameters.kvA_Y}`,
//         `KVA b: ${parameters.kvA_B}`,
//         `KVA T: ${parameters.kvat}`,
//       ],
//     },
//     {
//       title: "Real Power",
//       data: [
//         `kW r: ${parameters.kwr}`,
//         `kW y: ${parameters.kwy}`,
//         `kW b: ${parameters.kwb}`,
//         `kW T: ${parameters.kwt}`,
//       ],
//     },
//     {
//       title: "Reactive Power",
//       data: [
//         `kVAr r: ${parameters.kvA_R}`,
//         `kVAr y: ${parameters.kvA_Y}`,
//         `kVAr b: ${parameters.kvA_B}`,
//         `kVAr T: ${parameters.kvart}`,
//       ],
//     },
//     {
//       title: "PF",
//       data: [
//         `PF r: ${parameters.pfr}`,
//         `PF y: ${parameters.pfy}`,
//         `PF b: ${parameters.pfb}`,
//         `PF T: ${parameters.pft}`,
//       ],
//     },
//     {
//       title: "Energies",
//       data: [
//         `kWh Imp: ${parameters.kWhImport}`,
//         `kWh Exp: ${parameters.kwhexport}`,
//         `kVAh Imp: ${parameters.kVAh}`,
//         `kVAh Exp: ${parameters.kVArhTotal}`,
//       ],
//     },
//     {
//       title: "Voltage",
//       data: [
//         `V LL r: ${parameters.f}`,
//         `V LL y: ${parameters.kwd}`,
//         `V LL b: ${parameters.kvad}`,
//         `V LL Avg: ${parameters.powersupplyInteruption}`,
//       ],
//     },
//     {
//       title: "Current",
//       data: [
//         `I r: ${parameters.ir}`,
//         `I y: ${parameters.iy}`,
//         `I b: ${parameters.ib}`,
//         `I Avg: ${parameters.iavg}`,
//       ],
//     },

//   ];

//   console.log(parameters)

//   return (
//     <div
//       ref={componentRef}
//       className={`${isdarkMode ? "bg-transparent" : ""} pl-5 pt-0`}
//     >
//       {/* Header */}
//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
//         <div className="mt-0">
//           <Title level={4}>{parameters.metername}</Title>
//           <Text>Meter ID: <strong>{parameters.meterid}</strong></Text><br />
//           <Text>Last Poll: <strong>{parameters.createdon.replace("T"," ")}</strong></Text>
//           <Tag color={`${parameters.meterStatus=='ON'?"green":"red"}`} style={{ marginLeft: 8,paddingBottom:3 ,lineHeight:1.7}}>{parameters.meterStatus=='idle'?'Idle':parameters.meterStatus=='ON'?'Working':'OFF'}</Tag>
//         </div>
//         <Dropdown overlay={menu}>
//           <Button>
//             Download <DownOutlined />
//           </Button>
//         </Dropdown>
//       </div>

//       {/* Cards Grid */}
//       <Row gutter={[16, 16]}>
//         {sections.map((section, idx) => (
//           <Col xs={24} sm={12} md={12} lg={6} key={idx}>
//              <Title level={5} style={{ marginBottom: 8 }}>{section.title}</Title>
//             <Card size="small" bordered={false}>
//               {section.data.map((item, i) => (
//                 <div
//                   key={i}
//                   style={{
//                     backgroundColor: getCellColor(i+1, section.data.length),
//                     padding: "8px 12px",
//                     marginBottom: 8,
//                     borderRadius: 4,
//                   }}
//                   className="flex items-center justify-between"
//                 >
//                   <Text>{item}</Text>
//                 </div>
//               ))}
//             </Card>
//           </Col>
//         ))}
//       </Row>
//     </div>
//   );
// };

// export default EBMeterDashboard;
import React, { useRef, useState, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Drawer,
  Dropdown,
  Menu,
  Row,
  Tag,
  Typography,
} from "antd";
import { DownOutlined, SlidersOutlined } from "@ant-design/icons";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useSelector } from "react-redux";

const { Title, Text } = Typography;

// Optional utility for color styling
// const getCellColor = (index, total) => {
//   return index % 2 === 0 ? "#f6f6f6" : "#ffffff";
// };

const EBMeterDashboard = ({ parameters, data, showDrawer, open, onClose }) => {
  const componentRef = useRef(null);
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;

  const [currentIndex, setCurrentIndex] = useState(0);

  // On mount or when parameters/data change, find the initial index by meterid
  useEffect(() => {
    if (data?.length > 0 && parameters?.meterid) {
      const idx = data.findIndex((item) => item.meterid === parameters.meterid);
      if (idx !== -1) {
        setCurrentIndex(idx);
      }
    }
  }, [parameters, data]);

  const currentParams = data?.[currentIndex] || {};

const handleDownload = async (type) => {
  try {
    // Select only the Drawer panel (not the mask)
    const drawerElement = document.querySelector(".ant-drawer-content-wrapper");  
    if (!drawerElement) {
      console.error("Drawer content not found");
      return;
    }

    const canvas = await html2canvas(drawerElement, {
      scale: 2,  // sharper output
      useCORS: true,
      logging: false,
    });

    const dataURL = canvas.toDataURL("image/png");

    if (type === "png") {
      const link = document.createElement("a");
      link.href = dataURL;
      link.download = `${currentParams.metername || "drawer"}.png`;
      link.click();
    } else if (type === "pdf") {
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(dataURL);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      // Multi-page support if Drawer is taller than A4
      let y = 0;
      while (y < pdfHeight) {
        pdf.addImage(dataURL, "PNG", 0, -y, pdfWidth, pdfHeight);
        y += pdf.internal.pageSize.getHeight();
        if (y < pdfHeight) pdf.addPage();
      }

      pdf.save(`${currentParams.metername || "drawer"}.pdf`);
    }
  } catch (error) {
    console.error("Download error:", error);
  }
};



  // const menu = (
  //   <Menu  onClick={({ key }) => handleDownload(key)}>
  //     <Menu.Item key="png">Download as PNG</Menu.Item>
  //     <Menu.Item key="pdf">Download as PDF</Menu.Item>
  //   </Menu>
  // );
  const menu = (
    <Menu onClick={({ key }) => handleDownload(key)}>
      <Menu.Item key="png">Download as PNG</Menu.Item>
      <Menu.Item key="pdf">Download as PDF</Menu.Item>
    </Menu>
  );

  const handleNext = () => {
    if (currentIndex < data.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  const sections = [
    {
      title: "Summary",
      data: [
        `kVA T: ${currentParams.kvat}`,
        `kW T: ${currentParams.kwt}`,
        `I Avg: ${currentParams.iavg}`,
        `V LL Avg: ${currentParams.vllAvg}`,
      ],
    },
    {
      title: "Apparent Power",
      data: [
        `KVA r: ${currentParams.kvA_R}`,
        `KVA y: ${currentParams.kvA_Y}`,
        `KVA b: ${currentParams.kvA_B}`,
        `KVA T: ${currentParams.kvat}`,
      ],
    },
    {
      title: "Real Power",
      data: [
        `kW r: ${currentParams.kwr}`,
        `kW y: ${currentParams.kwy}`,
        `kW b: ${currentParams.kwb}`,
        `kW T: ${currentParams.kwt}`,
      ],
    },
    {
      title: "Reactive Power",
      data: [
        `kVAr r: ${currentParams.kvA_R}`,
        `kVAr y: ${currentParams.kvA_Y}`,
        `kVAr b: ${currentParams.kvA_B}`,
        `kVAr T: ${currentParams.kvart}`,
      ],
    },
    {
      title: "PF",
      data: [
        `PF r: ${currentParams.pfr}`,
        `PF y: ${currentParams.pfy}`,
        `PF b: ${currentParams.pfb}`,
        `PF T: ${currentParams.pft}`,
      ],
    },
    {
      title: "Energies",
      data: [
        `kWh Imp: ${currentParams.kWhImport}`,
        `kWh Exp: ${currentParams.kwhexport}`,
        `kVAh Imp: ${currentParams.kVAh}`,
        `kVAh Exp: ${currentParams.kVArhTotal}`,
      ],
    },
    {
      title: "Voltage",
      data: [
        `V ry: ${currentParams.vry}`,
        `V yb: ${currentParams.vyb}`,
        `V br: ${currentParams.vbr}`,
        `V LL Avg: ${currentParams.vllAvg}`,
      ],
    },
    {
      title: "Current",
      data: [
        `I r: ${currentParams.ir}`,
        `I y: ${currentParams.iy}`,
        `I b: ${currentParams.ib}`,
        `I Avg: ${currentParams.iavg}`,
      ],
    },
  ];
  // console.log(currentParams)

  return (
    // <div className="">

    // </div>
    <Drawer
    ref={componentRef}
      className={` ${isdarkMode ? "my-drawer-body anticon-close" : "#000000"} `}
      closable={false}
      title={
        <div className="flex justify-between items-center">
          <div className=" ">
            <div className="flex gap-3 h-fit mb-0">
              <SlidersOutlined className={` ${ currentParams.meterStatus === "idle"
                  ? "bg-yellow-500 "
                  : currentParams.meterStatus === "ON"
                    ? "bg-green-600 "
                    : "bg-red-600 " } text-4xl p-2 text-white`} />
              <Title className="" style={{color:isdarkMode?"white":"black"}} level={2}>
                {currentParams.metername}
              </Title>
            </div>
             <div className=" flex gap-3 mb-0">
            <div className="mt-0  flex flex-col ">
            <Text className={`${isdarkMode? "text-white":"text-black"} text-lg `}>
              Meter ID: <strong>{currentParams.meterid}</strong>
            </Text>
              <Text className={`${isdarkMode? "text-white":"text-black"} text-lg `}>
                Last Poll:{" "}
                <strong>{currentParams.createdon?.replace("T", " ")}</strong>
              </Text>
            </div>
           
              <Tag
                color={currentParams.meterStatus === "ON" ? "green" :currentParams.meterStatus==="OFF"? "red":"yellow"}
                style={{ marginLeft: 8, paddingBottom: 3 }}
                className="rounded-full h-8  text-center mt-5  w-32 text-lg "
              >
                {currentParams.meterStatus === "idle"
                  ? "Idle"
                  : currentParams.meterStatus === "ON"
                    ? "Working"
                    : "Off"}
              </Tag>
            </div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <Button  onClick={handlePrev} disabled={currentIndex === 0} className={`${currentIndex === 0?'text-white ':' '}`} >
              Previous
            </Button>
            <Button
            
              onClick={handleNext}
              disabled={currentIndex === data.length - 1}
            >
              Next
            </Button>
            <Dropdown overlay={menu}>
              <Button>
                Download <DownOutlined />
              </Button>
            </Dropdown>
          </div>
        </div>
      }
      showDrawer={showDrawer}
      open={open}
      onClose={onClose}
      width={"80%"}
      isStatusView={true}
    >
      <div className="flex flex-col gap-6 mt-2">
        <div
          
          className={`${isdarkMode ? "bg-transparent" : ""} pl-5 pt-0`}
        >
          {/* Header */}

          {/* Cards Grid */}
          <Row gutter={[16, 16]}>
            {sections.map((section, idx) => (
              <Col xs={24} sm={12} md={12} lg={6} key={idx}>
                <Title  level={5} style={{ marginBottom: 8 ,color:isdarkMode?"white":"black"}}>
                  {section.title}
                </Title>
                <Card size="small" bordered={true}  className= {`${isdarkMode? "bg-transparent":"bg-blue-50"} shadow-2xl`}>
                  {section.data.map((item, i) => (
                    <div
                      key={i}
                      style={{
                        backgroundColor: getCellColor(
                          i + 1,
                          section.data.length
                        ),
                        padding: "8px 12px",
                        marginBottom: 8,
                        borderRadius: 4,
                      }}
                      className="flex items-center justify-between"
                    >
                      <Text>{item}</Text>
                    </div>
                  ))}
                </Card>
              </Col>
            ))}
          </Row>
        </div>
        <div></div>

        {/* <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
              <Button onClick={onClose} className="">
                Cancel
              </Button>
              <Button
                type="primary"
                // disabled={!alertName.trim()}
                // onClick={handleAdd}
              >
                Add
              </Button>
            </div> */}
      </div>
    </Drawer>
  );
};

export default EBMeterDashboard;
